import React from "react";
import {css, Theme} from "@emotion/react";

import {flexAbsoluteCenter, mb, mr, onDesktop, pb, ph, pt, pv} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

const rentersLogoBlack = require("../images/renters_logo_black.svg");

export const InvestmentOfferPartnerSection = () => {
    return (
        <section css={investmentOfferPartnerSection}>
            <img css={[mb(2), onDesktop(mr(5), mb(0))]} src={rentersLogoBlack} alt="Renters logo" />
            <Text css={text} variant="body_copy_2">
                Partnerem merytorycznym sekcji jest firma Renters, specjalizująca się w zarządzaniu i inwestowaniu w krótkoterminowy najem mieszkań.
            </Text>
        </section>
    );
};

const investmentOfferPartnerSection = (theme: Theme) => css`
    background-color: #fff;
    ${pb(3)};
    ${ph(2)};
    ${pt()};
    ${flexAbsoluteCenter};
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
        ${pv()};
    }
`;

const text = (theme: Theme) => css`
    text-align: center;

    @media (min-width: ${theme.breakpoints.md}) {
        text-align: left;
        max-width: 54.6rem;
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {flexAbsoluteCenter, mb, mr, onDesktop, pb, ph, pt, pv} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

const rentersLogoBlack = require("../images/renters_logo_black.svg");

export const InvestmentOfferPartnerSection = () => {
    return (
        <section css={investmentOfferPartnerSection}>
            <img css={[mb(2), onDesktop(mr(5), mb(0))]} src={rentersLogoBlack} alt="Renters logo" />
            <Text css={text} variant="body_copy_2">
                Partnerem merytorycznym sekcji jest firma Renters, specjalizująca się w zarządzaniu i inwestowaniu w krótkoterminowy najem mieszkań.
            </Text>
        </section>
    );
};

const investmentOfferPartnerSection = (theme: Theme) => css`
    background-color: #fff;
    ${pb(3)};
    ${ph(2)};
    ${pt()};
    ${flexAbsoluteCenter};
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
        ${pv()};
    }
`;

const text = (theme: Theme) => css`
    text-align: center;

    @media (min-width: ${theme.breakpoints.md}) {
        text-align: left;
        max-width: 54.6rem;
    }
`;
